import { Component, Input, Output, EventEmitter, ViewChild, OnInit, ViewEncapsulation } from '@angular/core';
import { ShelvableBackend } from '../../services/ShelvableBackend/ShelvableBackend';
import { Shelf } from '../../services/ShelvableBackend/Shelf';
import { AllowDragDirective } from './directives/AllowDrag';
import { AllowDropDirective } from './directives/AllowDrop';
import { MiniBook } from '../../services/ShelvableBackend/BookArray'
import { PageMetadataService } from '../../services/PageMetadataService';
import { NgbDropdown } from '@mattlewis92/ng-bootstrap'
import { StateService } from '@uirouter/angular';

import { Observable } from 'rxjs'

@Component({
    selector: 'book',
    templateUrl: './book.html',
    styleUrls: ['./book.css'],
    encapsulation: ViewEncapsulation.None
})
export class BookComponent {
    @Input() book:MiniBook;
    @Input() popoverPlacement:string;
    @Input() leftButton:string;
    @Input() rightButton:string;
    @Input() centreButton:string;
    @Input() showPreviewIcon:boolean;
    @Input() allowDrag:boolean;

    @Output() onImageLoad:EventEmitter<void> = new EventEmitter<void>();

    @Output() onFinish:EventEmitter<void> = new EventEmitter<void>();
    @Output() onReread:EventEmitter<void> = new EventEmitter<void>();
    @Output() onRemove:EventEmitter<{noConfirm:boolean}> = new EventEmitter<{noConfirm:boolean}>();

    displayPriority = PageMetadataService.displayPriority;
    isViewingOwnLibrary = PageMetadataService.isViewingOwnLibrary;

    @ViewChild(NgbDropdown) dropdown:NgbDropdown;
    public closeDropdown() {
        this.dropdown.close();
    }

    loggedInUserShelves:Observable<Shelf[]>;
    constructor(shelvableBackend:ShelvableBackend, private stateService:StateService) {
        this.loggedInUserShelves = shelvableBackend.loggedInUserShelves;
    }

    async addToShelf() {
        if (this.stateService.current.name === 'shelf') {
            var shelfName = this.stateService.params.shelfName;

            var shelves = await this.loggedInUserShelves.take(1).toPromise();

            var matchingShelves = shelves.filter((shelf) => shelf.shelfName === shelfName);
            if (matchingShelves.length > 0) {
                matchingShelves[0].books.addBook(this.book.googleId, false); 
                this.flashBookAdded();
            }
        }
    }
    
    bookAddedIcon:boolean = false;
    bookAddedFade:boolean = false;
    flashBookAdded() {
        this.bookAddedIcon = true;
        setTimeout(() => {
            this.bookAddedIcon = false;
        }, 1000);
        
        this.bookAddedFade = true;
        setTimeout(() => {
            this.bookAddedFade = false;
        }, 2000);
    };

}


// WEBPACK FOOTER //
// ./web/static/components/book/book.ts